import React from "react";
import { Redirect } from "react-router-dom";
import { EXAMPLES_PATH } from "./constants";
import Home from "./Home";
import Icons from "./Icons";
import Root from "./Layouts/Root";
import NotFound from "./NotFound";
import License from "./License";
import Example from "./Example";
import About from "./About";
import Composer from "./Composer";
import Studio from "./Studio";

const routes = [
  {
    component: Root,
    routes: [
      {
        path: "/",
        exact: true,
        component: Home,
      },
      {
        path: "/icons",
        component: Icons,
        exact: true,
      },
      {
        path: "/composer",
        component: Composer,
        exact: true,
      },
      {
        path: "/studio",
        component: Studio,
        exact: true,
      },
      {
        path: "/about",
        component: About,
        exact: true,
      },
      {
        path: "/license",
        component: License,
        exact: true,
      },
      {
        // The old guide now lives in Examples (the server answers with a 301)
        path: "/how-to-use",
        exact: true,
        render: () => <Redirect to={EXAMPLES_PATH} />,
      },
      {
        path: "/examples",
        component: Example,
        exact: true,
      },
      {
        path: "*",
        component: NotFound,
        exact: true,
        // Full-screen page: no header or footer
        bare: true,
      },
    ],
  },
];

export default routes;
